import type { ArticleCardDataProps } from '@/app/components/ArticleCardsModule/ArticleCard';

const ARTICLE_CLASS_NAME = 'w-[75vw] bg-sandstone-400 md:w-[60vw] lg:w-full';
const HEADING_CLASS_NAME = 'text-xl';

const getPerimenopauseArticleCards = (
  localePartialUrl: string,
): ArticleCardDataProps[] => [
  {
    buttonProps: {
      ariaLabel: 'read_more',
      siteName: 'Oura',
      external: true,
      href: `https://ouraring.com/blog${localePartialUrl}perimenopause`,
    },
    className: ARTICLE_CLASS_NAME,
    heading: 'perimenopause_article_one',
    headingClassName: HEADING_CLASS_NAME,
  },
  {
    buttonProps: {
      ariaLabel: 'read_more',
      siteName: 'Oura',
      external: true,
      href: `https://ouraring.com/blog${localePartialUrl}menopausal-hormone-therapy-myths-and-facts`,
    },
    className: ARTICLE_CLASS_NAME,
    heading: 'perimenopause_article_two',
    headingClassName: HEADING_CLASS_NAME,
  },
  {
    buttonProps: {
      ariaLabel: 'read_more',
      siteName: 'Oura',
      external: true,
      href: `https://ouraring.com/blog${localePartialUrl}how-menopause-affects-sleep/`,
    },
    className: ARTICLE_CLASS_NAME,
    heading: 'perimenopause_article_three',
    headingClassName: HEADING_CLASS_NAME,
  },
];

export { getPerimenopauseArticleCards };
